/* eslint-disable global-require */
// Firebase only web

const params = new URLSearchParams(window.location.search);
const platform = params.get('p') !== undefined ? params.get('p') : 'web';

if (platform === 'web') {
	const firebase = require('firebase/app');
	require('firebase/messaging');

	const config = {
		apiKey: 'AIzaSyBsylcU3E39PXUHzQVU1v6LUHi1AeNAxeg',
		authDomain: 'gestios-acb9a.firebaseapp.com',
		databaseURL: 'https://gestios-acb9a.firebaseio.com',
		projectId: 'gestios-acb9a',
		storageBucket: 'gestios-acb9a.appspot.com',
		messagingSenderId: '119953531214',
		appId: '1:119953531214:web:626058e6e151988ca93e1f'
	};

	firebase.initializeApp(config);
	// firebase.analytics();

	const messaging = firebase.messaging();

	messaging.usePublicVapidKey('BD_ZFtgJRxZ9_5uF2XeOmLDK8DMjNvWqMLZt8dGMT2gDF2RyT3epr66eE4lVQw3eqMubSzaP_t1Qvf2GcqTA1O4'); // 1. Generate a new key pair

	// Request Permission of Notifications
	messaging
		.requestPermission()
		.then(() => {
			console.log('Notification permission granted.');

			// Get Token
			messaging.getToken().then((token) => {
				console.log(token);
			});
		})
		.catch((err) => {
			console.log('Unable to get permission to notify.', err);
		});
}
